import type { LegalBlock, LegalDoc } from '../content/pages/yasal';

/*
 * src/content/pages/yasal.ts'teki statik yasal metni, admin editörünün ürettiği HTML biçimine
 * çevirir. CMS'e ulaşılamadığında sayfa bu HTML'i çizer; böylece CMS'ten gelen metinle statik
 * yedek aynı bileşenden ve aynı görünümle geçer. (Backend'deki ilk aktarım da — SeedLegalDocuments
 * migration'ı — bu dönüşümle üretildi.)
 */

const escape = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/** `**kalın**` ve `[etiket](adres)` işaretleri → HTML. */
const inline = (s: string) =>
  escape(s)
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

const cell = (tag: 'th' | 'td', s: string) => `<${tag}><p>${inline(s)}</p></${tag}>`;

function block(b: LegalBlock): string {
  if (b.type === 'p') return `<p>${inline(b.text)}</p>`;
  if (b.type === 'list') return `<ul>${b.items.map((i) => `<li><p>${inline(i)}</p></li>`).join('')}</ul>`;
  const head = `<tr>${b.head.map((h) => cell('th', h)).join('')}</tr>`;
  const rows = b.rows.map((r) => `<tr>${r.map((c) => cell('td', c)).join('')}</tr>`).join('');
  return `<table><tbody>${head}${rows}</tbody></table>`;
}

const cache = new Map<LegalDoc, string>();

export function staticLegalHtml(doc: LegalDoc): string {
  let html = cache.get(doc);
  if (html === undefined) {
    html =
      doc.intro.map((t) => `<p>${inline(t)}</p>`).join('') +
      doc.sections.map((s) => `<h2>${escape(s.title)}</h2>${s.blocks.map(block).join('')}`).join('');
    cache.set(doc, html);
  }
  return html;
}
